(() => {
  'use strict';
  function init(root) {
    if(root.dataset.lmReady)return;
    root.dataset.lmReady='true';
    const priceBlock=root.querySelector('[data-lm-block="price"]');
    const header=root.querySelector('[data-lm-heading]');
    const mobileHeading=root.querySelector('[data-lm-mobile-heading]');
    const meta=root.querySelector('.product-single__meta');
    const blocks=root.querySelector('[data-product-blocks]');
    const form=root.querySelector('form.product-single__form');
    const select=root.querySelector('[data-product-select]');
    const add=root.querySelector('[data-add-to-cart]');
    const json=root.querySelector('[data-variant-json]');
    const sticky=document.querySelector(`[data-lm-owner="${root.id}"]`);
    if(!header||!mobileHeading)return;
    const headingAnchor=document.createComment('lm-heading-position');
    const priceAnchor=document.createComment('lm-price-position');
    header.before(headingAnchor);
    priceBlock?.before(priceAnchor);
    const merchandise=root.dataset.lmMerch==='true';
    const compact=root.dataset.lmCompactPurchase==='true';
    const quantityBlock=root.querySelector('[data-lm-block="quantity_selector"]');
    const buyBlock=root.querySelector('[data-lm-block="buy_buttons"]');
    // Keep the original quantity's form attribute and the entire native form intact.
    // Other products keep their existing layout; the opt-in is product-scoped in Liquid.
    if(merchandise&&form&&add&&blocks&&priceBlock&&quantityBlock&&buyBlock){
      const panel=document.createElement('div');
      panel.className='lm-pdp-purchase-panel';
      panel.dataset.lmPurchasePanel='';
      add.before(panel);
      panel.append(priceBlock,quantityBlock,add);
      blocks.prepend(buyBlock);
    }else if(compact&&blocks&&priceBlock&&quantityBlock&&buyBlock){
      const panel=document.createElement('div');
      panel.className='lm-pdp-purchase-panel';
      panel.dataset.lmPurchasePanel='';
      blocks.prepend(panel);
      panel.append(priceBlock,quantityBlock,buyBlock);
    }
    const mq=matchMedia('(max-width: 768px)');
    // Move the existing native controls, never clone them or replace their forms.
    const gizaDesktop=merchandise||(root.dataset.productId==='6969236455583'&&priceBlock);
    const optionNodes=gizaDesktop?[
      root.querySelector('.lm-pdp-colour-caption'),
      root.querySelector('.lm-pdp-colours'),
      root.querySelector('.lm-pdp-sizes')
    ].filter(Boolean):[];
    const optionOrigins=optionNodes.map(node=>{
      const anchor=document.createComment('lm-option-position');
      node.before(anchor);
      return {node,anchor};
    });
    const desktopOptions=gizaDesktop?document.createElement('div'):null;
    const changeLink=gizaDesktop?root.querySelector('.lm-pdp-selection a'):null;
    const originalChangeHref=changeLink?.getAttribute('href');
    if(desktopOptions){
      desktopOptions.className='lm-pdp-desktop-options';
      desktopOptions.id=`lm-desktop-options-${root.id}`;
    }
    function arrange(){
      if(mq.matches&&!merchandise){mobileHeading.append(header);if(priceBlock&&!compact)mobileHeading.append(priceBlock);}
      else{headingAnchor.after(header);if(priceBlock&&!compact)priceAnchor.after(priceBlock);}
      if(desktopOptions){
        root.classList.toggle('lm-pdp--desktop-options',!mq.matches);
        if(mq.matches&&!merchandise){
          optionOrigins.forEach(({node,anchor})=>anchor.after(node));
          desktopOptions.remove();
          if(changeLink&&originalChangeHref)changeLink.setAttribute('href',originalChangeHref);
        }else{
          if(compact)blocks.before(desktopOptions);
          else priceBlock.after(desktopOptions);
          optionNodes.forEach(node=>desktopOptions.append(node));
          if(changeLink)changeLink.setAttribute('href',`#${desktopOptions.id}`);
        }
        requestAnimationFrame(()=>window.dispatchEvent(new Event('resize')));
      }
    }
    arrange();
    mq.addEventListener('change',arrange);
    if(merchandise){const enquiry=root.querySelector('.lm-pdp-enquiry');if(enquiry&&blocks)blocks.before(enquiry);}
    if(!json||!form||!add)return;
    const variants=JSON.parse(json.value||json.textContent);
    function currentVariant(){
      const inputs=[...root.querySelectorAll('input[data-variant-input]:checked, select[data-variant-input]')];
      return (inputs.length ? variants.find(v=>inputs.every(input=>v['option'+input.dataset.index.replace('option','')]===input.value)) : null) ||
        variants.find(v=>String(v.id)===select?.value);
    }
    function sync(){
      const variant=currentVariant();
      const selected=variant?.title === 'Default Title' ? root.dataset.productTitle : (variant?.title || [...root.querySelectorAll('input[data-variant-input]:checked, select[data-variant-input]')].map(i=>i.value).join(' / '));
      root.querySelectorAll('[data-lm-selection]').forEach(el=>el.textContent=selected);
      const single=variant?.options?.some(v=>String(v).toLowerCase().includes('single'));
      root.querySelectorAll('[data-lm-pillow-count]').forEach(el=>el.textContent=single?'1':'2');
      if(sticky){
        sticky.querySelector('[data-lm-sticky-selection]').textContent=selected;
        const price=root.querySelector('[data-product-price]');
        if(price)sticky.querySelector('[data-lm-sticky-price]').textContent=price.textContent;
        const submit=sticky.querySelector('button');
        submit.disabled=add.disabled;
        submit.textContent=merchandise?root.dataset.lmStickyLabel:(add.querySelector('[data-add-to-cart-text]')?.textContent.trim()||add.textContent.trim());
        const overlayOpen=document.body.classList.contains('js-drawer-open') || !!document.querySelector('.Vtl-CartDrawer[aria-hidden="false"], .drawer.is-open, .modal--is-active');
        sticky.hidden=add.getBoundingClientRect().bottom>=0 || !mq.matches || overlayOpen || document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]),textarea,select');
      }
    }
    let frame;
    const queue=()=>{if(frame)return;frame=requestAnimationFrame(()=>{frame=null;sync()})};
    root.addEventListener('change',()=>{queue();setTimeout(queue,120)});
    root.addEventListener('focusin',queue);
    if(desktopOptions)root.addEventListener('focusin',event=>{
      if(mq.matches||!event.target.matches('input[data-color-name]'))return;
      event.target.nextElementSibling?.scrollIntoView({block:'nearest',inline:'nearest'});
    });
    root.addEventListener('focusout',queue);
    document.addEventListener('variant:change',queue);
    window.addEventListener('scroll',queue,{passive:true});
    window.addEventListener('resize',queue);
    new MutationObserver(queue).observe(add,{attributes:true,childList:true,subtree:true});
    new MutationObserver(queue).observe(document.body,{attributes:true,attributeFilter:['class']});
    const price=root.querySelector('[data-product-price]');
    if(price)new MutationObserver(queue).observe(price,{childList:true,subtree:true});
    sticky?.querySelector('[data-lm-sticky-submit]').addEventListener('click',()=>{
      // Use the real button so native validation and Zepto property handling run.
      if(merchandise){form.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}
      else if(!add.disabled)add.click();
    });
    sync();
  }
  const boot=()=>document.querySelectorAll('[data-lm-pdp]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
